export const ROUTES = {
  PERKZ_STORE: '/perkz-store',
  PROFILE: '/profile',
  PERKZ_WALLET: '/perkz-wallet',
  PROFILE_EDIT: '/profile/edit',
  ZS_ACTIVITY: '/profile/activity',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  HOW_IT_WORKS: '/how-it-works',
  LOGIN_CALLBACK: '/login/callback',
  SURPRISE_PERK: '/surprise-perk',
  REDEEM_Z_CODE: '/redeem-z-code',
  TAKEAWAY: '/takeaway',
  CLAIM_ZS: '/claim-zs',
  REFER_A_FRIEND: '/refer',
  SIGNUP: '/signup',
  WIN_A_SLICE: '/win-a-slice',
};
